import { ProjectDataService } from './project.data.service';
import { Observable, defer } from 'rxjs';
import { Project } from './project';
import { Injectable } from '@angular/core';
import { MmDbService } from '../../mm-db/mm-db-service';
import { MmProjectDbCollections } from '../../mm-db/mm-project-db-schema';

@Injectable()
export class ProjectOfflineService implements ProjectDataService {

  constructor(private readonly mmDbService: MmDbService) {


  }

  getProjectByMydocmaId(muid: string): Observable<Project> {
    return defer (async () => {
      const db = await this.mmDbService.getProjectDb(muid);
      const projects = await db.getAll(MmProjectDbCollections.project  as never);
      const project = projects ? projects[0] : null;
      return project;
    });
  }
}
